import { type FC } from 'react';
import {
    useAuctionCountdown,
    countdownToText,
} from 'dibs-crypto-utils/exports/useAuctionCountdown.ts';
import { FormattedMessage } from 'dibs-react-intl';

type Props = {
    endDate?: string | null;
};

export const PlaceBidCountdown: FC<Props> = ({ endDate }) => {
    const { countdownUnits } = useAuctionCountdown(endDate, true);
    return countdownUnits ? (
        <>
            {countdownToText(countdownUnits)}
            <FormattedMessage defaultMessage=" left" id="nft.pdp.bidModal.placeBidCountdown" />
        </>
    ) : null;
};
